import { Component, OnInit } from '@angular/core';
import {EntidadEmpresarialEntity, ServicioEntidadService} from '../../../services/servicio-entidad.service';
import {ActivatedRoute} from '@angular/router';
import {ServicioAdmisionesService} from '../../../services/servicio-admisiones.service';
import {LoginEntity, ServicioLoginService} from '../../../services/servicio-login.service';
import {HttpErrorResponse} from '@angular/common/http';
import {ImagesService} from '../../../services/utils/images.service';
import {ExcelService} from '../../../services/utils/excel.service';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-relacion-admisiones',
  templateUrl: './relacion-admisiones.component.html',
  styleUrls: ['./relacion-admisiones.component.css']
})
export class RelacionAdmisionesComponent implements OnInit {

  mensajeLoading = 'Cargando...';
  codigoBaseDatos: string;
  mensajeError: string;
  logo: string;

  usuario: LoginEntity = {};
  entidad: EntidadEmpresarialEntity = {};

  fechaImpresion: Date = new Date();

  constructor(
    private servicioAdmisiones: ServicioAdmisionesService,
    private servicioLogin: ServicioLoginService,
    private servicioImagenes: ImagesService,
    private servicioEntidad: ServicioEntidadService,
    private activatedRoute: ActivatedRoute,
    private servicioExcel: ExcelService,
    private datePipe: DatePipe
  ) {
    this.activatedRoute.params.subscribe( (params: any) => {
      this.codigoBaseDatos = params.codigoBaseDatos;
      this.uncoSede = params.uncoSede;
      this.uncoLogin = params.uncoLogin;
    });
  }

  private uncoSede: number;
  private uncoLogin: number;

  ngOnInit() {
    this.getLogo();
    this.getInformacionUsuario();
  }

  private async getLogo() {
    try {
      this.logo = '';
      this.mensajeLoading = 'Cargando información entidad ...';
      const response = await this.servicioImagenes.getLogo(this.codigoBaseDatos);
      response.subscribe((data: any) => {
        this.logo = data.source;
        this.getEntidadEmpresarial();
      }, (err: HttpErrorResponse) => {
        this.logo = null;
        this.getEntidadEmpresarial();
        console.error('Error RelacionAdmisionesComponent.getLogo()', err);
      });
    } catch (e) {
      this.logo = null;
      this.getEntidadEmpresarial();
      console.error('Catch RelacionAdmisionesComponent.getLogo()', e);
    }
  }

  private async getEntidadEmpresarial() {

    try {
      this.mensajeLoading = 'Cargando información entidad ...';
      const response = await this.servicioEntidad.getEntidadEmpresarial(this.codigoBaseDatos,
        this.uncoSede);
      response.subscribe((data: EntidadEmpresarialEntity[]) => {
        this.entidad = data[0];
        this.getInformacionUsuario();
      }, (err: HttpErrorResponse) => {
        this.mensajeLoading = '';
        this.mensajeError = 'Error al obtener información de la entidad, verifique conexión a internet. De lo contrario reporte caso al administrador.';
        console.error('Error RelacionAdmisionesComponent.getEntidadEmpresarial()', err);
      });
    } catch (e) {
      this.mensajeLoading = '';
      this.mensajeError = 'Error grave al obtener información de la entidad, verifique conexión a internet. De lo contrario reporte caso al administrador.';
      console.error('Catch RelacionAdmisionesComponent.getEntidadEmpresarial()', e);
    }
  }

  private async getInformacionUsuario() {
    try {
      this.mensajeLoading = 'Cargando información usuario ...';
      const response = await this.servicioLogin.getUsuario(this.codigoBaseDatos, this.uncoLogin);
      response.subscribe((data: LoginEntity) => {
        this.usuario = data;
        this.mensajeLoading = '';
      }, (err: HttpErrorResponse) => {
        this.mensajeLoading = '';
        this.mensajeError = 'Error al obtener información del usuario, verifique conexión a internet. De lo contrario reporte caso al administrador.';
        console.error('Error RelacionAdmisionesComponent.getInformacionUsuario()', err);
      });
    } catch (e) {
      this.mensajeLoading = '';
      this.mensajeError = 'Error al obtener información del usuario, verifique conexión a internet. De lo contrario reporte caso al administrador.';
      console.error('Catch RelacionAdmisionesComponent.getInformacionUsuario()', e);
    }
  }

  async onFiltrosCompletados(filtros: any) {

      const response = await this.servicioAdmisiones.getRelacionesAdmisiones(this.codigoBaseDatos, {
        lc_unco_sde_pnto_atncn : filtros.lc_unco_sde_pnto_atncn.join(),
        lc_unco_estdo_admsn : filtros.lc_unco_estdo_admsn.join(),
        ld_fcha_incl: filtros.ld_fcha_incl,
        ld_fcha_fnl : filtros.ld_fcha_fnl
      });
      response.subscribe((data: any[]) => {

        const dataOrganize = [];

        const map = {};
        for (const item of data) {
          if (!map[item.pnto_atncn_admsn]) {
            map[item.pnto_atncn_admsn] = [];
          }
          map[item.pnto_atncn_admsn].push(item);
        }

        // tslint:disable-next-line:forin
        for (const mapKey in map) {
          dataOrganize.push({
            'No admisión': 'Punto Atención: ' + map[mapKey][0].pnto_atncn_admsn,
            'Fecha admisión': '',
            'Fecha Salida admisión': '',
            'Afiliado': '',
            'Estado': '',
            'Punto Atención': ''
          });

          for (const item of map[mapKey]) {
            dataOrganize.push({
              'No admisión': item.cnsctvo_admsns,
              'Fecha admisión': this.datePipe.transform(item.fcha_admsn, 'dd/MM/yyyy hh:mm a'),
              'Fecha Salida admisión': this.datePipe.transform(item.fcha_slda_admsn, 'dd/MM/yyyy hh:mm a'),
              'Afiliado': item.afldo,
              'Estado': item.estdo_admsn,
              'Punto Atención': item.pnto_atncn_admsn
            });
          }
        }

        this.servicioExcel.exportAsExcelFile(dataOrganize, 'relación admisiones', 'sheet');
    }, (error) => {
      console.error('Error RelacionAdmisionesComponent.onFiltrosCompletados()', error);
      this.onErrorGenerado('Ocurrió un error al consultar las relaciones admisiones, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    });
  }

  isAvailableBody() {
    return !this.mensajeLoading && !this.mensajeError;
  }

  onErrorGenerado(error: string) {
    this.mensajeError = error;
  }
}
